(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("PrintScout", [], factory);
	else if(typeof exports === 'object')
		exports["PrintScout"] = factory();
	else
		root["PrintScout"] = factory();
})(window, function() {
return 